import namespace from './namespace';
import type { IEmoji } from '@/api/common';
import type { IUserLoginInfo, IUserPermission } from '@/api/user';
import type { IThreadLisItem } from '@/api/thread/list';
import type { ISubChannelTreeRes, BannerConfigType } from '@/api/home';
import { TrackFunctionType, TrackEventsType, extractThreadTagsType, getChannelNameBySlugType } from '@/utils/sensors';

export type channelDataType = {
  channelList: ISubChannelTreeRes[];
  articalList: {
    [key: string]: {
      data: IThreadLisItem[],
      offset: number,
      hasNextPage: boolean
    }
  };
  channelActiveKeys: string[];
  channelSortKeyMap: {
    [key: string]: string;
  };
  devicesSeriesName?: string;
  deviceName?: string;
};

export interface IState {
  [namespace.app]: {
    account?: IUserLoginInfo;
    sensors?: {
      track?: TrackFunctionType;
      TRACK_EVENTS?: TrackEventsType;
      extractThreadTags?: extractThreadTagsType;
      getChannelNameBySlug?: getChannelNameBySlugType;
    };
    permission?: IUserPermission;
  };
  [namespace.home]: {
    bannerList: BannerConfigType[];
    pcActiveChannelName?: string;
  } & channelDataType;
  [namespace.activity]: channelDataType;
  [namespace.detail]: {
    emojies: IEmoji[];
    deleteReasons: string[];
    ext: {
      tips: {
        type: string;
        value: number;
        message: string;
      }
    } | null;
    totalReplys: number;
  };
  [namespace.square]: channelDataType;
  [namespace.edit]: {};
  [namespace.consult]: channelDataType;
  [namespace.devices]: Record<string, channelDataType>;
  [namespace.device]: {
    [key: string]: channelDataType;
  };
  [namespace.profile]: {};
  [namespace.group]: {};
  [namespace.search]: {};
}

const defaultState = ():IState => ({
  [namespace.app]: {
    account: undefined,
    sensors: {
      track: undefined,
      TRACK_EVENTS: undefined,
      extractThreadTags: undefined,
      getChannelNameBySlug: undefined,
    },
    permission: undefined,
  },
  [namespace.home]: {
    bannerList: [],
    channelList: [],
    articalList: {},
    channelActiveKeys: [],
    channelSortKeyMap: {},
    pcActiveChannelName: '',
  },
  [namespace.activity]: {
    channelList: [],
    channelActiveKeys: [],
    channelSortKeyMap: {},
    articalList: {},
  },
  [namespace.detail]: {
    emojies: [],
    deleteReasons: [],
    ext: null,
    totalReplys: 0,
  },
  [namespace.square]: {
    channelList: [],
    articalList: {},
    channelActiveKeys: [],
    channelSortKeyMap: {},
  },
  [namespace.edit]: {

  },
  [namespace.consult]: {
    channelList: [],
    articalList: {},
    channelActiveKeys: [],
    channelSortKeyMap: {},
  },
  [namespace.devices]: {},
  [namespace.device]: {},
  [namespace.profile]: {},
  [namespace.group]: {},
  [namespace.search]: {},
});
export default defaultState;
